import React from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { capitalizeFirstLetter } from "../../../../helpers/util"
import { CancelButton } from "../../../../components/SkyFramework/Buttons"
import { gisRoutes } from "../../../../routes/routes";
// Local Libraries
import phrasebookLoad from "../../../../i18n";
import { serviceNumberTypeInfo } from '../../ServiceNumberType/serviceNumberTypeForm';
import { DisplayInfo } from "../../../../components/SkyFramework/Boxes/DisplayInfo";
import { ButtonBack } from "../../../../components/SkyFramework/ProgressTab/ButtonBack";
import { ButtonNext } from "../../../../components/SkyFramework/ProgressTab/ButtonNext";

//components

// Constants
const phrasebook = phrasebookLoad();

export default class DetailsProduct extends React.Component {

  render() {
    const { selectedTypeNumber, nextStep, prevStep } = this.props;
    if (selectedTypeNumber) {
      return (<>
        {serviceNumberTypeInfo(phrasebook, selectedTypeNumber)}
        <div className="box-actions-footer">
          <CancelButton
            link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} />
          <button
            className="btn btn-main"
            onClick={
              // this.handleOnNext
              nextStep
            }
          >
            {phrasebook.common.next}{" "}
          </button>
        </div>
      </>)
    } else return null;
  }
}
